class SizefinderComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;

      this.collectionLink = this.querySelector('.js.sizefinder__results__collection-link');
      this.footlengthSelect = this.querySelector('.js.footlength-select');
      this.overlay = this.querySelector('.js.sizefinder__help-overlay');
      this.shopShoesBtn = this.parentElement.parentElement.querySelector('.shop-shoes-btn');
      this.sizefinderResults = this.querySelector('.js.sizefinder__results');

      // check if we are on a PDP or the sizefinder section
      this.isPDP = this.dataset.type === 'pdp';

      if(this.isPDP) {
        this.sizingHint = document.querySelector('.js.sizing-hint');
        this.setSizingHintHeight();
        this.querySelector('.js.sizefinder__details')?.addEventListener('toggle', this.initializeOnCloseSizefinder.bind(this));
        this.createLinkToAllShoesCollection();
        this.collectionLink.addEventListener('click', this.datalayerDiscoverShoes);
      } else {
        this.shopShoesBtn?.addEventListener('click', this.datalayerDiscoverShoes);
      }

      // in the sizefinder section we might not have a help popu
      if (this.overlay) {
        this.initializeHelpPopup();
      }

      this.querySelector('.js.growing-feet__toggle-switch')?.addEventListener('change', this.onGrowingFeetToggle.bind(this))
    }

    /**
    * Set the CSS height in order to make the opening animation work
    */
    setSizingHintHeight() {
      if(!this.sizingHint) return;

      this.hintHeight = `${this.sizingHint.offsetHeight}px`;
      this.sizingHint.style.height = this.hintHeight;
    }

    initializeHelpPopup() {
      const overlay = this.querySelector('.js.sizefinder__help-overlay');

      this.querySelector('.js.sizefinder-help-btn')?.addEventListener('click', this.showHelpPopUp.bind(this));
      this.querySelector('.js.sizefinder-help-label')?.addEventListener('click', this.showHelpPopUp.bind(this));

      this.querySelectorAll('.js.sizefinder__help-modal__close-btn')?.forEach((closeBtn) =>{
        closeBtn.addEventListener('click', this.hideHelpPopup.bind(this));
      });

      overlay.addEventListener('click', this.hideHelpPopup.bind(this));
    }

    showHelpPopUp() {
      const overlay = this.querySelector('.js.sizefinder__help-overlay');
      this.querySelector('.js.sizefinder__help-modal').classList.remove('hidden');
      document.body.classList.add('overlay');
      overlay.classList.add('fadeIn', 'help-open');
      overlay.classList.remove('fadeOut'); // in case popup has been opened/closed before
      this.datalayerHelpOpened();
    }

    hideHelpPopup() {
      const overlay = this.querySelector('.js.sizefinder__help-overlay');
      document.body.classList.remove('overlay');
      overlay.classList.add('fadeOut');
      overlay.classList.remove('fadeIn', 'help-open');
      this.querySelector('.js.sizefinder__help-modal').classList.add('hidden');
    }

    initializeOnCloseSizefinder(event) {
      if (!event.currentTarget.hasAttribute('open')) {
        this.resetSizefinder();
        if(this.sizingHint) this.sizingHint.style.height = this.hintHeight;
        this.datalayerToggleSizefinder(true);
      } else {
        if(this.sizingHint) this.sizingHint.style.height = 0;
        this.datalayerToggleSizefinder(false);
      }
    }

    createLinkToAllShoesCollection() {
      // create link to "all" collection
      const languageTag = (location.href.includes('us-wildling') || location.href.includes('us.wildling')) ? '' : Shopify.locale.includes('en') ? '/en' : '';
      const allCollection = (location.href.includes('us-wildling') || location.href.includes('us.wildling'))  ? 'shop' : 'all';
      const collectionLinkFromBreadcrumbs = Array.from(document.querySelectorAll('.product-breadcrumb__link')).find((link) => link.href.includes('/collections'));

      // old system
      let ageCategory = (location.href.includes('us-wildling') || location.href.includes('us.wildling'))  ? 'Adults' : 'Erwachsene';
      const filterParam = 'tag';

      // new system
      // let ageCategory = 'Adults';
      // const filterParam = 'filter.p.m.custom.age';

      const ageTag = collectionLinkFromBreadcrumbs?.href.split(`?${filterParam}=`);

      if(ageTag && ageTag.length > 1) {
        const tagPart = ageTag[1];
        ageCategory = tagPart;
      }

      this.collectionLink.href = `${languageTag}/collections/${allCollection}?${filterParam}=${ageCategory}`;
    }

    resetSizefinder() {
      this.hideResults();
      this.footlengthSelect.reset();
    }

    /**
    * - Remove recommendation and hide recommendation elements
    */
    hideResults() {
      this.sizefinderResults.classList.remove('notify');
      this.sizefinderResults.classList.remove('soldout');
      this.sizefinderResults.classList.add('hidden');
    }

    onGrowingFeetToggle(event) {
      this.footlengthSelect.swapSizes();
      this.resetSizefinder();
      if(event.target.checked) { // growing feet
        this.datalayerToggleGrowingFeet(true);
      } else { // non-growing feet
        this.datalayerToggleGrowingFeet(false);
      }
    }

    datalayerToggleGrowingFeet(isGrowing) {
      const status = isGrowing ? 'yes' : 'no';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
      'event': 'groessenberater_growing_feet',
      'status': status
      });
    }

    datalayerToggleSizefinder(closed) {
      if (!closed) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'groessenberater_opened'
        });
      }
    }

    datalayerHelpOpened() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'groessenberater_help_requested'
      });
    }

    datalayerDiscoverShoes() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'groessenberater_discover_shoes'
      });
    }
  }

  customElements.define('sizefinder-component', SizefinderComponent);